<template>
  <div class="client_order_task-list">
    <div class="response_table">
<!--      <div class="header">-->
<!--        -->
<!--      </div>-->
      <table>
        <thead>
          <tr>
            <th scope="col" class="w50">
              {{ translate('client_order.task_list.id') }}
            </th>
            <th scope="col">
              {{ translate('client_order.task_list.device') }}
            </th>
            <th scope="col">
              {{ translate('client_order.task_list.auto_snapshot') }}
            </th>
            <th scope="col">
              {{ translate('client_order.task_list.apply_group_config') }}
            </th>
            <th scope="col">
              {{ translate('client_order.task_list.status') }}
            </th>
            <th scope="col">
              {{ translate('client_order.task_list.attempts') }}
            </th>
            <th scope="col">
              {{ translate('client_order.task_list.next_attempt_at') }}
            </th>
            <th scope="col">
              {{ translate('client_order.task_list.timeout_at') }}
            </th>
            <th scope="col">
              {{ translate('client_order.task_list.snapshot_id') }}
            </th>
            <th scope="col">
              {{ translate('client_order.task_list.last_error') }}
            </th>
            <th scope="col">
              {{ translate('client_order.task_list.created_at') }}
            </th>
            <th scope="col">
              {{ translate('client_order.task_list.updated_at') }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(task, task_key) in device_tasks" :key="task_key" class="device_task">
            <td :data-label="translate('client_order.task_list.id')" class="w50">
              {{ task.id }}
            </td>
            <td :data-label="translate('client_order.task_list.device')" class="device_name">
              <router-link :to="{path: '/device/' + task.device_fid}">
                {{ task.device_fid }}
              </router-link>
              <p>{{ task.device_name }}</p>
            </td>
            <td :data-label="translate('client_order.task_list.auto_snapshot')">
              {{ task.auto_snapshot }}
            </td>
            <td :data-label="translate('client_order.task_list.apply_group_config')">
              {{ task.apply_group_config }}
            </td>
            <td :data-label="translate('client_order.task_list.status')">
              {{ task.status }}
            </td>
            <td :data-label="translate('client_order.task_list.attempts')">
              {{ task.attempts }}
            </td>
            <td :data-label="translate('client_order.task_list.next_attempt_at')"
                v-html="get_date_any_lines(task.next_attempt_at, null, 2)">
            </td>
            <td :data-label="translate('client_order.task_list.timeout_at')">
              {{ task.timeout_at }}
            </td>
            <td :data-label="translate('client_order.task_list.snapshot_id')">
              {{ task.snapshot_id }}
            </td>
            <td :data-label="translate('client_order.task_list.last_error')">
              {{ task.last_error }}
            </td>
            <td :data-label="translate('client_order.task_list.created_at')"
                v-html="get_date_any_lines(task.created_at, null, 2)">
            </td>
            <td :data-label="translate('client_order.task_list.updated_at')"
                v-html="task.updated_at ? get_date_any_lines(task.updated_at, null, 2) : ''">
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

</template>
<script>

export default {
  name: 'ClientOrderTaskList',
  components: {

  },

  props: {
    client_order_id:{
      type: Number,
      required: true
    }
  },

  data() {
    return {
      device_tasks: []
    }
  },

  created() {
    this.get_device_tasks()
  },

  computed: {

  },

  watch: {
  },

  methods: {
    get_device_tasks () {
      this.$http.v1.getClientOrderDeviceTasks(this.client_order_id, (response) => {
        this.device_tasks = response.data
      })
    }

  }
}

</script>

<style lang='scss' scoped>
.client_order_task-list {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  overflow: auto;

  .response_table {
    height: auto;
    padding: 0;
    margin-bottom: 20px;
    margin-top: 10px;
  }
}
</style>
